import React, { useEffect } from 'react';
import { FileText, Download, Scale, Image, BookOpen, Shield } from 'lucide-react';
import '../styles/global.css';
import Carousel from '../components/Carousel';
function ChiffresAMZ () {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const brochures = [
    {
      id: 1,
      title: "ⴰⵎⵣⵉⵣⵣⵍ ⴰⵏⴰⵎⵓⵔ ⵏ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ: ⵎⴰⵅ, ⵎⴰⵏⵉ ⴷ ⵎⴰⵎⵏⴽ?",
       fileName: "depliant 16x16 amz.pdf",
      pages: "4 ⵏ ⵜⴰⵙⵏⴰ",
      size: "1 MB",
      icon: Shield,
      color: "#ff6b35"
    },
    {
      id: 2,
      title: "ⴰⵙⴳⵣⵍ ⵓⴱⵖⵉⵔ: ⵜⵉⴽⵕⴹⵉ ⵏⵏⴰ ⵜⵙⵙⵀⵡⴰⵏ ⵜⴰⵜⵉⴽⵏⵓⵍⵓⵊⵉⵜ",
 fileName: "مختصر مفيد العنف الذي تيسره التكنولوجيا.pdf",
      pages: "12 ⵏ ⵜⴰⵙⵏⴰ",
      size: "21 MB",
      icon: FileText,
      color: "#ff8555"
    },
    {
      id: 3,
      title: "ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ: ⵜⴰⴱⵔⴱⴰⵢⵢⵓⵕⵜ ⵉⴼⵙⵙⵜⴰⵏ ⵉⵙⴷⵉⴷⴷⵉⵢⵏ ⴰⵎⵓⵏ",
 fileName: "العنف الرقمي ضد النساء بالفتيات جائحة صامة تهدد المجتمع.pdf",
      pages: "2 ⵏ ⵜⴰⵙⵏⴰ",
      size: "4 MB",
      icon: BookOpen,
      color: "#ff6b35"
    }
  ];

  const legalTexts = [
    {
      id: 1,
      title: "القانون رقم 103.13",
      subtitle: "محاربة العنف ضد النساء",
      description: "النص الكامل للقانون المتعلق بمحاربة العنف ضد النساء، بما في ذلك الأحكام الخاصة بالعنف الرقمي والتحرش الإلكتروني",
      year: "2018",
      articles: "20 مادة"
    },
    {
      id: 2,
      title: "القانون رقم 05-20",
      subtitle: "الأمن السيبراني",
      description: "الإطار القانوني للأمن السيبراني وحماية المعطيات الشخصية في الفضاء الرقمي",
      year: "2020",
      articles: "15 مادة"
    },
    {
      id: 3,
      title: "القانون رقم 09-08",
      subtitle: "حماية الأشخاص الذاتيين",
      description: "قانون حماية الأشخاص الذاتيين تجاه معالجة المعطيات ذات الطابع الشخصي",
      year: "2009",
      articles: "58 مادة"
    },
    {
      id: 4,
      title: "مشروع قانون الجرائم الإلكترونية",
      subtitle: "الإطار التشريعي الجديد",
      description: "مشروع القانون الجديد المتعلق بمكافحة الجرائم الإلكترونية والعنف الرقمي",
      year: "2024",
      articles: "في طور المصادقة"
    }
  ];

  const photoGallery = [
    {
      id: 1,
      title: "ورشة توعوية حول العنف الرقمي - الرباط",
      image: "/images/2.jpeg"
    },
    {
      id: 2,
      title: "لقاء مع ضحايا العنف الرقمي",
      image: "/images/3.jpeg"
    },
    {
      id: 3,
      title: "حملة التوعية في الجامعات المغربية",
      image: "/images/4.jpeg"
    },
    {
      id: 4,
      title: "ندوة حول القوانين المغربية ضد العنف الرقمي",
      image: "/images/5.jpeg"
    },
    {
      id: 5,
      title: "تدريب الشباب على الحماية الرقمية",
      image: "/images/6.jpeg"
    },
    {
      id: 6,
      title: "مسيرة ضد العنف الرقمي - الدار البيضاء",
      image: "/images/7.jpeg"
    },
    {
      id: 7,
      title: "شهادات الناجيات من العنف الرقمي",
      image: "/images/8.jpeg"
    },
    {
      id: 8,
      title: "ورشة مع الإعلاميين حول تغطية قضايا العنف",
      image: "/images/9.jpeg"
    },
    {
      id: 9,
      title: "برنامج دعم نفسي للضحايا",
      image: "/images/10.jpeg"
    }
  ];

  // Fonction pour télécharger le PDF
  const handleDownload = (fileName, title) => {
    const link = document.createElement('a');
    link.href = `/documents/${fileName}`;
    link.download = fileName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="digital-violence-page" style={{ backgroundColor: '#1a1a1a', minHeight: '100vh' }}>


    {/* Hero Section */}
    <div style={{
      padding: '80px 0 40px',
      textAlign: 'center',
      backgroundImage: 'url(/images/cover.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      width: '100%',
      marginLeft: 'calc(-50vw + 50%)',
      minHeight: '400px'
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: 1
      }}></div>
      <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>

      <style jsx>{`
        @media (max-width: 768px) {
          .caravan-page > div:nth-child(1) {
            padding: 60px 0 30px !important;
            min-height: 300px !important;
          }
          .caravan-page h1 {
            font-size: 2.5rem !important;
          }
          .caravan-page h3 {
            font-size: 1.5rem !important;
          }
        }
      `}</style>

      <h1 style={{
        fontSize: '3.5rem',
        marginBottom: '20px',
        background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        textAlign: 'center'
      }}>
      ⵜⵉⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ: ⵓⵟⵟⵓⵏⵏ ⴷ ⵜⵏⵜⴰⵎⵉⵏ
      </h1>

      </div>
    </div>




      {/* Brochures Section */}
      <div className="container" style={{ padding: '60px 0',   direction:'ltr' }}>
        <div style={{ textAlign: '-webkit-center', marginBottom: '50px'}}>
          <h2 style={{
            fontSize: '2.5rem',
            color: '#ffffff',
            marginBottom: '15px',



            gap: '15px',


          }}>
            <BookOpen size={40} color="#ff6b35" />
          ⵜⴰⵣⵓⵏⵉ ⵏ ⵜⵓⴹⴼⵉⵚⵉⵏ
          </h2>
          <p style={{
            fontSize: '1.2rem',
            color: '#b0b0b0',
            maxWidth: '600px'

          }}>
            ⵜⵉⵥⵕⵉⴳⵉⵏ ⵜⵉⵎⵙⵙⴼⵔⴽⵉⵏ ⵜⵉⵖⵣⵓⵔⴰⵏⵉⵏ ⵉⵣⵎⵔⵏ ⴰⴷ ⵜⵜⵡⴰⴳⴰⵎⵏⵜ ⴷ ⴰⴷ ⵜⵜⵓⵣⵣⵉⴳⵣⵉⵏⵜ
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '30px',
          marginBottom: '40px',
        }}>
          {brochures.map((brochure, index) => {
            const Icon = brochure.icon;
            return (
              <div key={brochure.id} style={{
                background: 'linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%)',
                borderRadius: '20px',
                padding: '35px',
                border: '1px solid rgba(255, 107, 53, 0.2)',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                position: 'relative',
                overflow: 'hidden',
                textAlign:'left',
                direction:'left'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.borderColor = brochure.color;
                e.currentTarget.style.boxShadow = `0 10px 30px rgba(255, 107, 53, 0.3)`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = 'rgba(255, 107, 53, 0.2)';
                e.currentTarget.style.boxShadow = 'none';
              }}>
                <div style={{
                  position: 'absolute',
                  top: '20px',
                  left: '20px',
                  width: '60px',
                  height: '60px',
                  borderRadius: '15px',
                  background: `${brochure.color}20`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s ease'
                }}>
                  <Icon size={32} color={brochure.color} />
                </div>

                <div style={{ marginTop: '60px' }}>
                  <h3 style={{
                    fontSize: '1.3rem',
                    color: '#ffffff',
                    marginBottom: '20px',
                    fontWeight: '700',
                    lineHeight: '1.5',
                    textAlign: 'left'
                  }}>
                    {brochure.title}
                  </h3>

                  <div style={{
                    display: 'flex',
                    gap: '15px',
                    marginBottom: '25px',
                    flexWrap: 'wrap'
                  }}>
                    <span style={{
                      padding: '8px 15px',
                      background: 'rgba(255, 107, 53, 0.15)',
                      borderRadius: '8px',
                      fontSize: '0.9rem',
                      color: '#ff6b35',
                      fontWeight: '600'
                    }}>
                      {brochure.pages}
                    </span>
                    <span style={{
                      padding: '8px 15px',
                      background: 'rgba(255, 107, 53, 0.15)',
                      borderRadius: '8px',
                      fontSize: '0.9rem',
                      color: '#ff6b35',
                      fontWeight: '600'
                    }}>
                      {brochure.size}
                    </span>
                  </div>

                  <button
                    onClick={() => handleDownload(brochure.fileName, brochure.title)}
                    style={{
                      width: '100%',
                      padding: '15px',
                      background: `linear-gradient(135deg, ${brochure.color}, ${brochure.color}dd)`,
                      color: '#ffffff',
                      border: 'none',
                      borderRadius: '12px',
                      fontSize: '1rem',
                      fontWeight: '600',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '10px'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.03)';
                      e.currentTarget.style.boxShadow = `0 8px 20px ${brochure.color}40`;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}>
                    <Download size={20} />
                    ⴰⴳⴰⵎ ⵏ ⵜⴷⵍⵉⵙⵜ
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="section-separator2"></div>

      {/* Legal Framework Section */}
      <div className="container" style={{ padding: '60px 0', direction:'ltr' }}>
        <div style={{ textAlign: 'center', marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2.5rem',
            color: '#ffffff',
            marginBottom: '15px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: '15px',
            textAlign: 'left'
          }}>
            <Scale size={40} color="#ff6b35" />
            ⵜⵉⵏⵜⴰⵎⵉⵏ ⵜⵉⵙⴰⵖⵓⵍⵉⵏ : ⵜⵉⴷⵙⵜⴰⵔⵉⵏ, ⵜⵉⵣⵣⵔⴰⴼⵉⵏ ⴷ ⵜⴳⵔⴰⵖⵍⴰⵏⵉⵏ
          </h2>
          <p style={{
            fontSize: '1.2rem',
            color: '#b0b0b0',
            maxWidth: '800px',
            lineHeight: '1.8',
            textAlign: 'left'
          }}>
            ⴰⴷⵓⵙⵜⵓⵔ, ⴰⵙⵍⴳⵏ ⴰⵎⵖⵔⵉⴱⵉ, ⵜⵉⵎⵢⴰⵇⵇⴰⵏⵉⵏ ⴷ ⵜⴰⵏⴰⴹⵉⵏ ⵜⵉⵏⵎⵜⵜⴰⵏⵉⵏ ⴷ ⵜⵙⴳⴰⵡⴰⵏⵉⵏ ⵉⵥⵍⵉⵏ ⵙ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⴷ ⵜⴽⵕⴹⵉ ⵏⵏⴰ ⵜⵙⵙⵀⵡⴰⵏ ⵜⴰⵜⵉⴽⵏⵓⵍⵓⵊⵉⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '30px',
          marginBottom: '40px',
          direction:'ltr',
          textAlign:'left'

        }}>
          {[
            {
              title: "ⴰⴷⵓⵙⵜⵓⵔ ⵏ ⵜⴳⵍⴷⵉⵜ ⵏ ⵍⵎⵖⵔⵉⴱ 2011",
              year: "",
              desc: "ⴰⵙⴰⵜⵉ ⴰⴷⵙⵜⴰⵔ ⵉⵙⴷⵓⵙⵏ ⵉⵙⴽⵉⵍ ⵏⴳⵔ ⵜⴰⴳⴳⴰⵢⵉⵏ ⴷ ⵡⴰⴷⴰ ⵉⵙⴳⴷⴰⵍⵏ ⴰⵙⵏⵓⵃⵢⵓ",
              link:"https://www.refworld.org/pdfid/3fb9eb164.pdf"
            },
            {
              title: "ⴰⵙⵍⴳⵏ 103.13 ⵉⵥⵍⵉⵏ ⵙ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ",
              year: "ⵉⵙⵙⵏⵜⵉ ⵓⵣⵣⴳⵉⵔ ⵏⵏⵙ ⴰⵙⴳⴳⵯⴰⵙ ⵏ 2018",
              desc: "ⴰⵙⵍⴳⵏ ⴰⵖⵣⵓⵔⴰⵏ ⵉ ⵓⵙⴱⴷⴷⵉ ⵏ ⴰⴽⴽⵯ ⵜⵉⵡⵉⵍⴰⵜⵉⵏ ⵏ ⵜⴽⵕⴹⵉ ⵎⴳⴰⵍ ⵜⴰⵎⵖⴰⵔⵜ",
              link:"https://adala.justice.gov.ma/production/legislation/ar/nouveautes/Loi%2013-103%20relative%20%C3%A0%20la%20lutte%20contre%20les%20violences%20faites%20aux%20femmes.pdf"
            },
            {
              title: "ⵜⴰⵎⵢⴰⵇⵇⴰⵏⵜ ⵏ ⵓⵙⴱⴷⴷⵉ ⵏ ⴰⴽⴽⵯ ⵜⵉⵡⵉⵍⴰⵜⵉⵏ ⵏ ⵓⵙⵏⵓⵃⵢⵓ ⵎⴳⴰⵍ ⵜⴰⵎⵖⴰⵔⵜ (CEDAW)",
              year: "ⵖⵜⵙⵏⵜ ⵜⵜ ⵜⵎⵜⵜⴰ ⵉⵎⵓⵏⵏ ⴰⵙⴳⴳⵯⴰⵙ ⵏ 1979",
              desc: "ⵜⴰⵏⵜⴰⵎⵜ ⵏ ⵉⵣⵔⴼⴰⵏ ⵉⴳⵔⴰⵖⵍⴰⵏⵏ ⵏ ⵜⵡⵜⵎⵉⵏ",
              link:"https://www.ohchr.org/sites/default/files/cedaw_SP.pdf"
            },
            {
              title: "ⵜⴰⵎⵢⴰⵇⵇⴰⵏⵜ ⵏ ⵓⵙⵇⵇⵉⵎ ⵏ ⵓⵕⵓⴱⴱⴰ ⵉ ⵡⴰⵔⴰⵢ ⵙⴳ ⵜⴽⵕⴹⵉ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ",
              year: "ⵜⴰⵎⵢⴰⵇⵇⴰⵏⵜ ⵏ ⵉⵙⵟⴰⵏⴱⵓⵍ - 11 ⵎⴰⵢⵢⵓ 2011",
              desc: "ⵜⴰⵎⵢⴰⵇⵇⴰⵏⵜ ⵜⴰⵖⵣⵓⵔⴰⵏⵜ ⵉ ⵓⵙⴳⴷⵍ ⴷ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⵎⴳⴰⵍ ⵜⴰⵎⵖⴰⵔⵜ ⴷ ⵜⴽⵕⴹⵉ ⵏ ⵜⴳⵎⵎⵉ",
              link:"https://rm.coe.int/168046253d"
            },
            {
              title: "ⵜⴰⵏⴰⴹⵜ ⵏ ⵜⵎⵏⵇⵉⵙⵜ ⵜⴰⵎⵥⵍⴰⵢⵜ ⵅⴼ ⵜⴽⵕⴹⵉ ⴳ ⵡⴰⵏⵜⵉⵔⵏⵉⵜ",
              year: "A/HRC/38/47 - ⴰⵙⴳⴳⵯⴰⵙ ⵏ 2018",
              desc: "ⵜⵉⴽⵕⴹⵉ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ ⴳ ⵓⵥⵟⵟⴰ ⵏ ⵡⴰⵏⵜⵉⵔⵏⵉⵜ ⵙⴳ ⵓⵎⵏⵉⴷ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ",
              link:"https://www.ohchr.org/sites/default/files/Documents/Issues/Women/SR/ReportOnlineViolence.pdf"
            },
            {
              title: "ⵜⴰⵏⴰⴹⵜ ⵏ ⵓⵏⴼⵍⵓⵙ ⴰⵎⴰⵜⴰⵢ ⵏ ⵜⵎⵜⵜⴰ ⵉⵎⵓⵏⵏ",
              year: "8 ⴽⵟⵓⴱⵕ 2024",
              desc: "ⵜⴰⵏⴰⴹⵜ ⵏ ⵓⵏⴼⵍⵓⵙ ⴰⵎⴰⵜⴰⵢ – ⵜⴰⵙⵓⵜⵍⵜ ⵜⵉⵙ ⵜⵥⴰ ⴷ ⵙⴰⵎⵔⴰⵡ ⵏ ⵓⴳⵔⴰⵡ ⴰⵎⴰⵜⴰⵢ: ⴰⵙⴳⴳⵓⵜ ⵏ ⵜⵓⴳⴳⴰⵙ ⵉ ⵓⵙⴱⴷⴷⵉ ⵏ ⴰⴽⴽⵯ ⵜⵉⵡⵉⵍⴰⵜⵉⵏ ⵏ ⵜⴽⵕⴹⵉ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ: ⵜⵉⴽⵕⴹⵉ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ ⵏⵏⴰ ⵜⵙⵙⵀⵡⴰⵏ ⵜⴰⵜⵉⴽⵏⵓⵍⵓⵊⵉⵜ",
              link: null
            },
            {
              title: "ⵜⴰⵏⴰⴹⵜ ⵏ ⵓⵙⵇⵇⵉⵎ ⴰⵏⴰⵎⵓⵔ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ",
              year: "22 ⴷⵓⵊⴰⵏⴱⵉⵔ 2024",
              desc: "ⵜⴰⵏⴰⴹⵜ ⵏ ⵓⵙⵇⵇⵉⵎ ⴰⵏⴰⵎⵓⵔ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ ⵅⴰⴼ ⵓⵙⵙⵔⵇⴱ ⵏ ⵓⵙⵉⵡⴹ ⵅⴼ ⵜⴽⵕⴹⵉ ⵎⴳⴰⵍ ⵜⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ ⴷ ⵓⵙⴱⴷⴷⵉ ⵏ ⵡⴰⵔ ⴰⴼⴼⵔⵜⵍ ⵙⴳ ⵜⵎⵔⵔⵓⵜ",
              link: "https://cndh.ma/ar/node/6011"
            },
            {
              title: "ⴰⵍⵖⵓ ⴷ ⵓⵖⴰⵡⴰⵙ ⵏ ⵜⵡⵓⵔⵉ ⵏ ⴱⵉⵊⵉⵏ",
              year: "ⴰⵙⴳⴳⵯⴰⵙ ⵏ 1995",
              desc: "ⴰⵖⴰⵡⴰⵙ ⵏ ⵜⵡⵓⵔⵉ ⴰⵎⵣⵔⴰⵢ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵜⵎⵖⴰⵔⵜ ⴷ ⵢⵉⵙⴽⵉⵍ ⵏⴳⵔ ⵜⴰⴳⴳⴰⵢⵉⵏ",
              link:"https://www.un.org/womenwatch/daw/beijing/pdf/BDPfA%20S.pdf"
            },
            {
              title: "ⴰⵍⵖⵓ ⴷ ⵓⵖⴰⵡⴰⵙ ⵏ ⵜⵡⵓⵔⵉ ⵏ ⴼⵢⵉⵏⵏⴰ",
              year: "ⴰⵙⴳⴳⵯⴰⵙ ⵏ 1993",
              desc: "ⵜⴰⵏⵜⴰⵎⵜ ⵜⴰⵎⵣⵔⴰⵢⵜ ⵅⴼ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ ⵖ ⴰⵎⵓⵏ ⴰⵡⴷ ⵉⵣⵔⴼⴰⵏ ⵏ ⵜⵎⵖⴰⵔⵜ",
              link:"https://www.ohchr.org/sites/default/files/vienna.pdf"
            },
            {
              title: "ⴰⵍⵖⵓ ⴰⵎⴰⴹⵍⴰⵏ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ",
              year: "10 ⴷⵓⵊⴰⵏⴱⵉⵔ 1948",
              desc: "ⵜⴰⵏⵜⴰⵎⵜ ⵜⴰⴷⵙⵍⴰⵏⵜ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵓⴼⴳⴰⵏ ⵉⵖⵣⵓⵔⴰⵏⵏ",
              link:"https://www.un.org/ar/udhrbook/pdf/udhr_booklet_ar_web.pdf"
            },

            {
              title: "ⴰⵡⵜⵜⴰⵙ ⵡⵉⵙⵙ ⵙⵎⵎⵓⵙ ⵙⴳ ⵉⵡⵜⵜⴰⵙⵏ ⵏ ⵜⴳⵎⵉ ⵜⴰⵙⵓⵍⴰⵏⵜ",
              year: "ⴰⵖⴰⵡⴰⵙ ⵏ 2030",
              desc: "ⴰⵍⴽⴰⵎ ⵙ ⵢⵉⵙⴽⵉⵍ ⵏⴳⵔ ⵜⴰⴳⴳⴰⵢⵉⵏ ⴷ ⵓⵙⵣⵎⵔ ⵏ ⵎⴰⵕⵕⴰ ⵜⵉⵎⵖⴰⵔⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ",
              link:"https://www.un.org/sustainabledevelopment/ar/wp-content/uploads/sites/2/2017/01/wim_dgs5.pdf"
            }
          ].map((ref, index) => (
            <div key={index} style={{
              background: 'linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%)',
              borderRadius: '20px',
              padding: '30px',
              border: '1px solid rgba(255, 107, 53, 0.2)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.borderColor = '#ff6b35';
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(255, 107, 53, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = 'rgba(255, 107, 53, 0.2)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <h3 style={{
                fontSize: '1.4rem',
                color: '#ff6b35',
                marginBottom: '15px',
                fontWeight: '700',
                textAlign: 'left'
              }}>
                {ref.title}
              </h3>
              {ref.year && (
                <p style={{
                  fontSize: '1rem',
                  color: '#b0b0b0',
                  lineHeight: '1.7',
                  marginBottom: '10px',
                  textAlign: 'left'
                }}>
                  {ref.year}
                </p>
              )}
              <p style={{
                fontSize: '0.95rem',
                color: '#999',
                lineHeight: '1.6',
                marginBottom: '20px',
                textAlign: 'left'
              }}>
                {ref.desc}
              </p>
              {ref.link ? (
                <a href={ref.link}
                   target="_blank"
                   rel="noopener noreferrer"
                   style={{
                     display: 'inline-block',
                     padding: '10px 20px',
                     background: '#ff6b35',
                     color: '#ffffff',
                     borderRadius: '8px',
                     textDecoration: 'none',
                     fontSize: '0.95rem',
                     fontWeight: '600',
                     transition: 'all 0.3s ease'
                   }}
                   onMouseEnter={(e) => e.currentTarget.style.background = '#ff8555'}
                   onMouseLeave={(e) => e.currentTarget.style.background = '#ff6b35'}>
                  ⵉⵥⵕⵉ ⵏ ⵜⵏⵜⴰⵎⵜ
                </a>
              ) : (
                <div style={{
                  padding: '10px 15px',
                  background: 'rgba(255, 107, 53, 0.1)',
                  borderRadius: '8px',
                  fontSize: '0.9rem',
                  color: '#ff6b35',
                  textAlign: 'center'
                }}>
                  ⵉⵍⵍⴰ ⴳ ⵓⵙⵉⵜ ⵏ ⵜⵎⵜⵜⴰ ⵉⵎⵓⵏⵏ
                </div>
              )}
            </div>
          ))}
        </div>

        <div style={{
          background: 'linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%)',
          padding: '30px',
          borderRadius: '15px',
          borderLeft: '4px solid var(--primary-orange)',
          marginTop: '30px',
          textAlign: 'left',

        }}>
          <p style={{
            fontSize: '1.1rem',
            color: '#e0e0e0',
            lineHeight: '1.8',
            marginBottom: '0',
            textAlign: 'left',
              direction:'ltr'
          }}>
            ⵎⴰⵕⵕⴰ ⵜⵉⵏⵜⴰⵎⵉⵏ ⴰⴷ ⴳⴰⵏⵜ ⴰⵙⴰⵜⵉ ⴰⵣⵔⴼⴰⵏ ⴷ ⵓⵙⴰⵖⵓⵍ ⴰⵖⵣⵓⵔⴰⵏ ⵉ ⵓⵎⵙⵜⴰⵢ ⵏ ⵉⵣⵔⴼⴰⵏ ⵏ ⵜⵡⵜⵎⵉⵏ ⴷ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⵎⴳⴰⵍⵏⵙⵏⵜ ⴳ ⵓⵙⵡⵉⵔ ⴰⵏⴰⵎⵓⵔ ⴷ ⵓⴳⵔⴰⵖⵍⴰⵏ
          </p>
        </div>
      </div>

      <div className="section-separator2"></div>

      {/* Photo Gallery Section */}
      <div className="container" style={{ padding: '60px 0',   direction:'ltr' }}>
        <div style={{ textAlign: 'center', marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2.5rem',
            color: '#ffffff',
            marginBottom: '15px',
            display: 'flex',
            alignItems: 'center',

            gap: '15px',
            textAlign: 'center'
          }}>
            <Image size={40} color="#ff6b35" />
            ⵜⵓⵙⵙⵉⴼⵉⵏ ⵏ ⵓⵙⵏⴼⵍⵓⵍ ⵏ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ
          </h2>

        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '30px',
          marginBottom: '40px'
        }}>
          {photoGallery.map((photo, index) => (
            <div key={photo.id} style={{
              background: 'linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%)',
              borderRadius: '20px',
              overflow: 'hidden',
              border: '1px solid rgba(255, 107, 53, 0.2)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.borderColor = '#ff6b35';
              e.currentTarget.style.boxShadow = '0 15px 40px rgba(255, 107, 53, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = 'rgba(255, 107, 53, 0.2)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <div style={{
                width: '100%',
                height: '280px',
                background: 'linear-gradient(135deg, #3a3a3a 0%, #2a2a2a 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  background: `repeating-linear-gradient(
                    45deg,
                    transparent,
                    transparent 10px,
                    rgba(255, 107, 53, 0.05) 10px,
                    rgba(255, 107, 53, 0.05) 20px
                  )`
                }}></div>
                <img
                     src={photo.image}
                     alt={photo.title}
                     style={{
                       width: '100%',
                       height: '100%',
                       objectFit: 'cover',
                       transition: 'transform 0.3s ease'
                     }}
                     onMouseEnter={(e) => {
                       e.currentTarget.style.transform = 'scale(1.05)';
                     }}
                     onMouseLeave={(e) => {
                       e.currentTarget.style.transform = 'scale(1)';
                     }}
                   />
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: '60px',
                  background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)'
                }}></div>
              </div>

            </div>
          ))}
        </div>
      </div>

      <div className="section-separator2"></div>



      {/* Call to Action */}
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <h3 style={{
          fontSize: '2.5rem',
          marginBottom: '25px',
          color: 'var(--white)',
          textAlign: 'center'
        }}>
        ⴰⵎⵣⵉⵣⵣⵍ ⵏⵅⵏⵉ ⵢⴰⴷ ⵉ ⵓⵙⴱⴷⴷⵉ ⵏ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ
        </h3>
        <p style={{
          fontSize: '1.3rem',
          marginBottom: '30px',
          color: 'var(--text-light)',
          lineHeight: '1.8',
          textAlign: 'center'
        }}>

        ⵜⵓⵙⵙⵏⴰ ⵙ ⵓⵟⵟⵓⵏⵏ ⴷ ⵉⵣⵔⴼⴰⵏ ⵉⴳⴰⵜ ⴰⵎⵔⵖ ⴰⵎⵣⵡⴰⵔⵓ ⴳ ⵓⵎⵏⵖⵉ ⵎⴳⴰⵍ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ. ⴽⵓ ⵢⴰⵏ ⵜⵏⵜⴰⵎⵜ ⴷⴰ ⵜⴳⴰⵜ ⵢⴰⵏ ⵓⴽⵙⴰⵢ ⵙ ⴰⵎⵓⵏ ⴰⵎⵓⵟⵟⵓⵏ ⵉⵏⴰⴼⴰⵏ ⵉ ⵎⴰⵕⵕⴰ.

        </p>
            <Carousel />
      </div>
    </div>

  );
};

export default ChiffresAMZ;
